import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full h-[420px] md:h-[560px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20artistic%20illustration%2C%20vibrant%20colorful%20comic%20panel%20collage%2C%20warm%20orange%20and%20coral%20gradients%2C%20stylized%20dynamic%20composition%20with%20action%20lines%2C%20modern%20digital%20art%20aesthetic%2C%20abstract%20comic%20book%20elements%2C%20clean%20professional%20design%2C%20no%20text&width=1600&height=800&seq=hero-bg-korean-comic&orientation=landscape"
        alt="韩国漫画网 - 免费韩漫在线阅读"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 leading-tight font-heading">
          韩国漫画网 - 免费韩漫大全
        </h1>
        <p className="text-sm md:text-base text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
          海量正版韩国漫画免费在线阅读，与韩国同步更新最新章节。热血、恋爱、校园、奇幻等多种类型，畅享无广告沉浸式阅读体验。
        </p>

        <form onSubmit={handleSearch} className="flex items-center max-w-md mx-auto bg-background-50/95 backdrop-blur-sm rounded-full overflow-hidden shadow-lg">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="搜索你喜欢的韩漫..."
            className="flex-1 px-5 py-3.5 text-sm text-foreground-800 placeholder-foreground-400 bg-transparent focus:outline-none"
          />
          <button
            type="submit"
            className="px-6 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="flex flex-wrap justify-center gap-2 mt-6">
          {['热血', '恋爱', '奇幻', '悬疑', '搞笑', '校园'].map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 text-xs rounded-full bg-background-50/15 text-background-50 backdrop-blur-sm whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-colors"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}